import React, { createContext, useContext, useState } from 'react';

const CountryContext = createContext();

export const useCountry = () => {
  const context = useContext(CountryContext);
  if (!context) {
    throw new Error('useCountry must be used within a CountryProvider');
  }
  return context;
};

export const CountryProvider = ({ children }) => {
  const [selectedCountry, setSelectedCountry] = useState({
    name: "Kuwait",
    code: "ku",
    timezone: "Asia/Kuwait"
  });

  const countries = [
    { name: "Kuwait", code: "ku", timezone: "Asia/Kuwait" },
    { name: "United States", code: "us", timezone: "America/New_York" },
  ];

  return (
    <CountryContext.Provider value={{
      selectedCountry,
      setSelectedCountry,
      countries
    }}>
      {children}
    </CountryContext.Provider>
  );
};